const KWAI_CLICK_ID_STORAGE_KEY = "kwai_click_id";
const KWAI_CLICK_ID_TIME_STORAGE_KEY = "kwai_click_id_time";
const KWAI_CLICK_ID_QUERY_KEYS = ["kwai_click_id", "kwai_clickid"];
const KWAI_CLICK_ID_FALLBACK_QUERY_KEYS = ["click_id", "clickid"];

const normalizeKwaiClickId = (value) => {
  const clickId = `${value || ""}`.trim();
  if (!clickId) {
    return "";
  }
  if (clickId.toLowerCase() === "null" || clickId.toLowerCase() === "undefined") {
    return "";
  }
  if (/^__.+__$/.test(clickId)) {
    return "";
  }
  return clickId;
};

const getLocationSearch = (location) => {
  if (location && typeof location.search == "string") {
    return location.search;
  }
  if (typeof window != "undefined" && window.location) {
    return window.location.search;
  }
  return "";
};

const getLocationPathname = (location) => {
  if (location && typeof location.pathname == "string") {
    return location.pathname;
  }
  if (typeof window != "undefined" && window.location) {
    return window.location.pathname;
  }
  return "";
};

const getLocationChannel = (location, query, channel) => {
  if (channel) {
    return `${channel}`.toLowerCase();
  }
  const queryChannel = query.get("c");
  if (queryChannel) {
    return queryChannel.toLowerCase();
  }
  const pathname = getLocationPathname(location);
  if (pathname.startsWith("/c/")) {
    return pathname.substring(3).toLowerCase();
  }
  return "";
};

const isKwaiChannel = (channel) => {
  return ["zaikwai", "kwai"].includes(`${channel || ""}`.toLowerCase());
};

export const SaveKwaiClickIdFromLocation = (location, channel) => {
  if (typeof localStorage == "undefined") {
    return "";
  }

  let query = null;
  try {
    query = new URLSearchParams(getLocationSearch(location));
  } catch (error) {
    console.error("SaveKwaiClickIdFromLocation failed", error);
    return "";
  }
  const locationChannel = getLocationChannel(location, query, channel);
  let kwaiClickId = "";
  for (let i = 0; i < KWAI_CLICK_ID_QUERY_KEYS.length; i++) {
    kwaiClickId = normalizeKwaiClickId(query.get(KWAI_CLICK_ID_QUERY_KEYS[i]));
    if (kwaiClickId) {
      break;
    }
  }
  if (!kwaiClickId && isKwaiChannel(locationChannel)) {
    for (let i = 0; i < KWAI_CLICK_ID_FALLBACK_QUERY_KEYS.length; i++) {
      kwaiClickId = normalizeKwaiClickId(query.get(KWAI_CLICK_ID_FALLBACK_QUERY_KEYS[i]));
      if (kwaiClickId) {
        break;
      }
    }
  }

  if (!kwaiClickId) {
    return "";
  }

  localStorage.setItem(KWAI_CLICK_ID_STORAGE_KEY, kwaiClickId);
  localStorage.setItem(KWAI_CLICK_ID_TIME_STORAGE_KEY, `${Date.now()}`);
  return kwaiClickId;
};

export const GetKwaiClickId = (location, channel) => {
  const currentKwaiClickId = SaveKwaiClickIdFromLocation(location, channel);
  if (currentKwaiClickId) {
    return currentKwaiClickId;
  }
  if (typeof localStorage == "undefined") {
    return "";
  }
  return normalizeKwaiClickId(localStorage.getItem(KWAI_CLICK_ID_STORAGE_KEY));
};

export const AppendKwaiClickId = (params, location, channel) => {
  const kwaiClickId = GetKwaiClickId(location, channel || (params && params.channel));
  if (kwaiClickId) {
    params.kwai_click_id = kwaiClickId;
  }
  return params;
};
